import {TripbookRepository} from "../../../repositories/TripbookRepository.ts";

export class ShareTripbookUseCase{
    constructor(private tripbooksRepository: TripbookRepository){}
    async execute(tripbookId: string, email: string): Promise<void>{
        return this.tripbooksRepository.shareTripbook(tripbookId, email);
    }
}
